import { useContext, useMemo } from 'react'

import { snakeCase } from 'lodash'
import { useSelector } from 'react-redux'

import { selectTranslate } from '../../../../reducers/LocaleReducer/LocalReducer'
import { GlobalContext } from '../../../../Providers/GlobalProvider'
import { isNonEmptyArray } from '../../../../utils'
import EntitiesSelector from '../EntitiesSelector'

const InstitutionConstraintsSelector = ({ institutionConstraints, className = '', disabled, multiple = 'default', style = {}, values, onChange }) => {
  const t = useSelector(selectTranslate)
  const gc = useContext(GlobalContext)

  const entities = useMemo(() => isNonEmptyArray(institutionConstraints) ? institutionConstraints : gc.studentMetadata, [institutionConstraints, gc?.studentMetadata])

  const constraintsOptions = useMemo(() => entities.map(propertyName => ({
    label: t('common.' + snakeCase(propertyName)),
    value: propertyName,
    tooltip: t('common.' + snakeCase(propertyName)),
  })), [entities, t])

  return (
    <EntitiesSelector
      className={className}
      disabled={disabled}
      entityOptions={constraintsOptions}
      multiple={multiple}
      showSearch
      style={style}
      values={values}
      onChange={onChange}
    />
  )
}

export default InstitutionConstraintsSelector